import React, {Component} from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend, LabelList, Cell,
} from 'recharts';
import {Loader} from 'semantic-ui-react';
import {getNumericValue} from '../../../../common/util/fieldsValidation';
import {colors} from '../../../../common/constants/colors';

class BarChartInHistoricalSales extends Component {
  formatValue = (value) => {
    const valueFormmated = getNumericValue(value, 0);
    return `${valueFormmated}`;
  }

  getYAxisWidth = () => {
    const {infoType} = this.props;
    switch (infoType) {
      default:
      case 'dealers':
      case 'reservations':
        return 310;
      case 'models':
        return 230;
      case 'colors':
        return 100;
    }
  }

  renderQuantityBar = () => {
    const {infoType, data} = this.props;
    const hasQuantityData = data && data[0] ? data[0] : {};
    if (!hasQuantityData.quantity) {
      return null;
    }
    if (infoType === 'colors') {
      return (
        <Bar dataKey='quantity' fill='#FFF' name='Cantidad'>
          {this.changeBarColor()}
          <LabelList dataKey='quantity' position='right' formatter={this.formatValue} />
        </Bar>
      );
    }
    return (
      <Bar dataKey='quantity' fill='#FFF' name='Cantidad' onClick={this.handleOnOrdersClick}>
        {this.changeBarColor()}
        <LabelList dataKey='quantity' position='right' formatter={this.formatValue} />
      </Bar>
    );
  }

  renderStockBar = () => {
    const {infoType, data} = this.props;
    const hasStockData = data && data[0] ? data[0] : {};
    if (!hasStockData.stock) {
      return null;
    }
    if (infoType === 'colors') {
      return (
        <Bar dataKey='stock' fill='#FFF' name='Stock'>
          {this.changeBarColor()}
          <LabelList dataKey='stock' position='right' formatter={this.formatValue} />
        </Bar>
      );
    }
    return (
      <Bar dataKey='stock' fill='#FFF' name='Stock' onClick={this.handleOnOrdersClick}>
        {this.changeBarColor()}
        <LabelList dataKey='stock' position='right' formatter={this.formatValue}
          content={this.renderCustomizedLabel} />
      </Bar>
    );
  }

  handleOnOrdersClick = (data) => {
    const {infoType} = this.props;
    this.props.onActiveBarClick(data.code, infoType);
  }

  changeBarColor = () => {
    const {data} = this.props;
    return (
      data.map((entry, index) => (
        <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
      ))
    );
  }

  renderCustomizedLabel = (props) => {
    const {value, x, y, width, height, fill} = props;
    return (
      <text x={x + width + 10} y={y + 5 + height / 2}
        fontSize={10}
        fill={fill}
      >
        {value}
      </text>
    );
  };

  render() {
    const {data, loading} = this.props;
    if (loading) {
      return (
        <div className='empty-chart'>
          <Loader active inline='centered' />
        </div>
      );
    }
    if (!data || !data.length) {
      return (
        <div className='empty-chart'>
          No hay datos con los filtros seleccionados
        </div>
      );
    }

    return (
      <ResponsiveContainer width='100%' height={350}>
        <BarChart layout='vertical' data={data}
          margin={{'top': 20, 'right': 70, 'left': 0, 'bottom': 5}} maxBarSize={35} >
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis type='number' allowDecimals={false} />
          <YAxis dataKey='name' type='category' width={this.getYAxisWidth()} interval={0} tick={{'fontSize': 11}} />
          
          <Legend />

          {this.renderQuantityBar()}
          {this.renderStockBar()}

        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default BarChartInHistoricalSales;
